// extracted by mini-css-extract-plugin
export default {"canvas":"backgroundDrawer__canvas__i8E1T","hidden":"backgroundDrawer__hidden__qlB8m"};